// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as actions from '../actions';
import EventCard from './EventCard';
import List from '../../common/components/list/List';
import CardGroup from '../../common/components/ui/CardGroup';

class EventsList extends Component {
  componentWillMount() {
    this.loadData();
  }

  loadData() {
    const { loadEvents } = this.props;
    loadEvents()//.then();
  }

  handleLoadMoreClick = () => {
    this.props.loadEvents(true);
  }

  renderEvent = (event) => {
    return (
      <EventCard
        key={event.id}
        event={event}
      />
    );
  }

  render() {
    const { paginatedEvents, pagination } = this.props;
    return (
      <List
        Container={CardGroup}
        items={paginatedEvents}
        renderItem={this.renderEvent}
        onLoadMoreClick={this.handleLoadMoreClick}
        {...pagination}
      />
    );
  }
};

const mapStateToProps = (state, { params }) => {
  const {
    entities: { events },
    pagination: { eventsPaginated },
  } = state;

  const pagination = eventsPaginated || { ids: [] };
  const paginatedEvents = pagination.ids.map(id => events[id])

  return {
    pagination,
    paginatedEvents,
  }
};

EventsList = withRouter(connect(
  mapStateToProps,
  actions
)(EventsList));

export default EventsList;



// WEBPACK FOOTER //
// ./src/modules/events/components/EventsList.js